import React from "react";
import Footer from "../../../common/Footer.js";
import AnalystSideNav from "../../../common/AnalystSideNav.js";
import AdminSideNav from "../../../common/AdminSideNav.js";
import UnauthorisedPage from "../../Unauthorised";
import TopNav from "../../../common/TopNav.js";
import { connect } from "react-redux";
import { withAlert } from "react-alert";
import Select from "react-select";
import authorizeAnalystOrAdmin from "../../../hoc/authorizeAnalystOrAdmin.js";
import requireAuth from "../../../hoc/requireAuth";
import DateRangePicker from "react-bootstrap-daterangepicker";
import * as moment from "moment";
import "../../../assets/css/check-duplicate.css";

class CheckDuplicate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authorised: true,
      company: "",
      brand: "",
      platform: "",
      companies: [],
      brands: [],
      errorMessage: {},
      urls: "",
      uniqueUrls: "",
      duplicateUrls: [],
      isSubmitting: false,
      numOfDuplicate: 0,
      numOfUnique: 0,
      date: null,
    };
  }

  getDateFilters() {
    return {
      startDate: moment(),
      endDate: moment(),
      locale: { format: "DD/MM/YYYY" },
    };
  }

  handleCallback = (start, end, _) => {
    const startDate = start.format("YYYY-MM-DD");
    const endDate = end.format("YYYY-MM-DD");

    this.setState((val) => ({ ...val, date: { startDate, endDate } }));
  };

  componentDidMount() {
    this.getCompanies();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.company !== this.state.company) {
      this.getBrands();
    }
  }

  async getCompanies() {
    await window.axios
      .get("/company", { params: { perPage: 100 } })
      .then((res) => {
        this.setState({ companies: res.data.docs });
      });
  }

  async getBrands() {
    await window.axios
      .get("/brand", {
        params: {
          disabledBrands: true,
          company: this.state.company,
          page: 1,
          perPage: 800,
        },
      })
      .then((res) => {
        this.setState({ brands: res.data.docs });
      });
  }

  changeCompanySelectBox = (e) => {
    this.setState({
      company: e.target.value,
      brand: "",
      brands: [],
    });
  };

  handleChangeBrand = (selectedOption) => {
    this.setState({ brand: selectedOption?.value || "" });
  };

  changePlatformSelectBox = (e) => {
    this.setState({ platform: e.target.value });
  };

  getUniqueUrls = (urls) => {
    return Array.from(
      new Set(
        urls
          .split(/\r?\n/)
          .map((url) => url.trim())
          .filter(Boolean),
      ),
    ).join("\n");
  };

  getRequestErrorMessage = (err) => {
    return (
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Something went wrong"
    );
  };

  downloadDuplicateCsv = () => {
    const rows = this.state.duplicateUrls || [];
    if (rows.length === 0) return;

    const escape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const header = ["Company", "Brand", "URL", "Reporting Date"];
    const lines = rows.map((r) =>
      [
        r.company,
        r.brand,
        r.url,
        r.reportingDate ? new Date(r.reportingDate).toLocaleDateString() : "",
      ]
        .map(escape)
        .join(","),
    );
    const csv = [header.map(escape).join(","), ...lines].join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `duplicate-urls-${Date.now()}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  sendTextToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Text copied to clipboard");
    } catch (error) {
      console.log("Clipboard copy failed:", error);
    }
  };

  handleSubmit = async () => {
    this.setState({ isSubmitting: true });
    try {
      const urls = this.getUniqueUrls(this.state.urls);
      this.setState({ errorMessage: {} });

      if (!this.state.company) {
        this.setState((prevState) => {
          return {
            errorMessage: { ...prevState.errorMessage, companyError: true },
          };
        });
      }

      if (!urls) {
        this.setState((prevState) => {
          return {
            errorMessage: {
              ...prevState.errorMessage,
              urlsError: true,
              urlsErrorMessage: "Please paste valid .txt content.",
            },
          };
        });
      }

      if (!this.state.platform) {
        this.setState((prevState) => {
          return {
            errorMessage: { ...prevState.errorMessage, platformError: true },
          };
        });
      }

      if (!this.state.company || !urls || !this.state.platform) {
        setTimeout(() => {
          this.setState({ errorMessage: {} });
        }, 4000);
        return;
      }

      if (urls !== this.state.urls) {
        this.setState({ urls });
      }

      const { data } = await window.axios.post("/services/duplicate-check", {
        company: this.state.company,
        brand: this.state.brand,
        platform: this.state.platform,
        urls,
        ...(this.state.date && { date: this.state.date }),
      });

      const { uniqueUrls, duplicateUrls } = data;

      this.setState({
        duplicateUrls,
        uniqueUrls: uniqueUrls.length > 0 ? uniqueUrls.join("\n") : "",
        numOfDuplicate: duplicateUrls.length,
        numOfUnique: uniqueUrls.length,
      });
    } catch (err) {
      const message = this.getRequestErrorMessage(err);

      if (message === "Invalid URLs") {
        this.setState((prevState) => ({
          errorMessage: {
            ...prevState.errorMessage,
            urlsError: true,
            urlsErrorMessage: message,
          },
          duplicateUrls: [],
          uniqueUrls: "",
          numOfDuplicate: 0,
          numOfUnique: 0,
        }));
      }

      this.props.alert.show(message, { type: "error" });
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  renderHtml() {
    if (!this.state.authorised) return <UnauthorisedPage />;

    const brandOptions = [
      { value: "", label: "Select Brand" },
      ...this.state.brands.map((brand) => ({
        value: brand.id,
        label: brand.brandName,
      })),
    ];

    const duplicateText = (this.state.duplicateUrls || [])
      .map((d) => (typeof d === "string" ? d : d.url))
      .join("\n");
    const inputUrlCount = this.state.urls
      ? this.getUniqueUrls(this.state.urls).split("\n").filter(Boolean).length
      : 0;

    return (
      <div className="row" id="check-duplicate-screen">
        {this.props?.login?.user?.role === "Admin" ? (
          <AdminSideNav />
        ) : (
          <AnalystSideNav />
        )}

        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
          <TopNav />

          <div className="main-content-container container-fluid px-4">
            <div className="page-header row no-gutters py-2 duplicate-header">
              <div className="col-12">
                <div className="row align-items-center">
                  <div className="col-12 col-sm-4 text-sm-left mb-0">
                    <span className="text-uppercase page-subtitle">
                      Duplicate Check
                    </span>
                  </div>

                  <div className="col-12 col-sm-8 mt-3 mt-sm-0">
                    <div className="duplicate-summary">
                      <div className="duplicate-summary-item">
                        <span className="duplicate-summary-value">
                          {inputUrlCount}
                        </span>
                        <span className="duplicate-summary-label">Input</span>
                      </div>
                      <div className="duplicate-summary-item">
                        <span className="duplicate-summary-value">
                          {this.state.numOfUnique}
                        </span>
                        <span className="duplicate-summary-label">
                          No Duplicate
                        </span>
                      </div>
                      <div className="duplicate-summary-item">
                        <span className="duplicate-summary-value">
                          {this.state.numOfDuplicate}
                        </span>
                        <span className="duplicate-summary-label">
                          Duplicate
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card card-small check-duplicate-card mb-4">
              <div className="card-header border-bottom duplicate-card-header">
                <div>
                  <h6 className="m-0">Search Criteria</h6>
                </div>
                <div className="check-duplicate-status">
                  {inputUrlCount > 0 && <span>{inputUrlCount} input URLs</span>}
                  {this.state.isSubmitting && (
                    <span className="text-primary">Checking...</span>
                  )}
                </div>
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <label className="check-duplicate-label">Company*</label>
                      <select
                        onChange={this.changeCompanySelectBox}
                        className={`form-control ${
                          this.state.errorMessage.companyError
                            ? "is-invalid"
                            : ""
                        }`}
                        value={this.state.company}
                      >
                        <option value="">Select from dropdown</option>
                        {this.state.companies.map((company) => (
                          <option key={company.id} value={company.id}>
                            {company.name}
                          </option>
                        ))}
                      </select>
                      {this.state.errorMessage.companyError && (
                        <div className="invalid-feedback">
                          Please select a company.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <label className="check-duplicate-label">Brand</label>
                      <Select
                        className="check-duplicate-select"
                        classNamePrefix="check-duplicate-select"
                        options={brandOptions}
                        onChange={this.handleChangeBrand}
                        value={brandOptions.find(
                          (opt) => opt.value === this.state.brand,
                        )}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <label className="check-duplicate-label">Platform*</label>
                      <select
                        value={this.state.platform}
                        onChange={this.changePlatformSelectBox}
                        className={`form-control ${
                          this.state.errorMessage.platformError
                            ? "is-invalid"
                            : ""
                        }`}
                      >
                        <option value="">Select Platform</option>
                        <option value="domain">Domain</option>
                        <option value="website">Website</option>
                        <option value="social-media">Social Media</option>
                        <option value="e-commerce">E-commerce</option>
                        <option value="app-store">App Store</option>
                      </select>
                      {this.state.errorMessage.platformError && (
                        <div className="invalid-feedback">
                          Please select a platform.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="form-group">
                      <label className="check-duplicate-label">
                        Date Range
                      </label>
                      <DateRangePicker
                        onCallback={this.handleCallback}
                        initialSettings={this.getDateFilters()}
                        alwaysShowCalendars={true}
                      >
                        <input className="form-control" />
                      </DateRangePicker>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group mb-0">
                      <label className="check-duplicate-label">Links</label>
                      <textarea
                        value={this.state.urls}
                        onChange={(e) => {
                          this.setState((prevState) => ({
                            urls: e.target.value,
                            errorMessage: {
                              ...prevState.errorMessage,
                              urlsError: false,
                              urlsErrorMessage: "",
                            },
                          }));
                        }}
                        className={`form-control check-duplicate-textarea ${
                          this.state.errorMessage.urlsError ? "is-invalid" : ""
                        }`}
                        rows="7"
                        placeholder="Paste URLs here"
                      />
                      {this.state.errorMessage.urlsError && (
                        <div className="invalid-feedback">
                          {this.state.errorMessage.urlsErrorMessage ||
                            "Please paste valid .txt content."}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-12 d-flex justify-content-between mt-3">
                    <button
                      type="button"
                      onClick={() => this.setState({ urls: "" })}
                      className="btn btn-white"
                      disabled={this.state.isSubmitting || !this.state.urls}
                    >
                      Clear Input
                    </button>
                    <button
                      type="button"
                      onClick={this.handleSubmit}
                      className="btn btn-primary"
                      disabled={this.state.isSubmitting}
                    >
                      <i className="material-icons">search</i>
                      {this.state.isSubmitting
                        ? "Checking..."
                        : "Check Duplicate"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row check-duplicate-results">
              <div className="col-lg-6">
                <div className="card card-small check-duplicate-card check-result-card mb-4">
                  <div className="card-header border-bottom duplicate-card-header">
                    <div>
                      <h6 className="m-0">Unique URLs</h6>
                    </div>
                    <div className="check-duplicate-result-actions">
                      {this.state.numOfUnique !== 0 && (
                        <span className="badge badge-light">
                          {this.state.numOfUnique}
                        </span>
                      )}
                      <button
                        className="btn btn-sm btn-white"
                        onClick={() =>
                          this.sendTextToClipboard(this.state.uniqueUrls)
                        }
                        disabled={!this.state.uniqueUrls}
                        title="Copy"
                        type="button"
                      >
                        <i className="material-icons">content_copy</i>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <textarea
                      className="form-control check-duplicate-result-textarea"
                      rows="10"
                      placeholder="No duplicate URLs here..."
                      value={this.state.uniqueUrls}
                      readOnly
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="card card-small check-duplicate-card check-result-card mb-4">
                  <div className="card-header border-bottom duplicate-card-header">
                    <div>
                      <h6 className="m-0">Duplicate URLs</h6>
                    </div>
                    <div className="check-duplicate-result-actions">
                      {this.state.numOfDuplicate !== 0 && (
                        <span className="badge badge-light">
                          {this.state.numOfDuplicate}
                        </span>
                      )}
                      <button
                        className="btn btn-sm btn-white"
                        disabled={this.state.numOfDuplicate === 0}
                        onClick={this.downloadDuplicateCsv}
                        title="Download for more details, including company, brand, and reporting date"
                        type="button"
                      >
                        CSV
                      </button>
                      <button
                        className="btn btn-sm btn-white"
                        onClick={() => this.sendTextToClipboard(duplicateText)}
                        disabled={!duplicateText}
                        title="Copy"
                        type="button"
                      >
                        <i className="material-icons">content_copy</i>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <textarea
                      className="form-control check-duplicate-result-textarea"
                      rows="10"
                      placeholder="Duplicate URLs here..."
                      value={duplicateText}
                      readOnly
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </main>
      </div>
    );
  }

  render() {
    return <>{this.renderHtml()}</>;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  login: state.login,
  response: state.response,
});

export default withAlert()(
  connect(mapStateToProps)(
    authorizeAnalystOrAdmin(requireAuth(CheckDuplicate)),
  ),
);
